import React from 'react'

const Card_4 = (props) => {
    const {title, subTitle} = props;
    return (
        <>
            <style>
                {
                    `
                    `
                }
            </style>
            <div className="title-wrapper">
                <h3 className="title text-grad-3 fs-1">
                    {title}
                </h3>
            </div>
            <div className="text-wrapper">
                <p className="text fs-3 text-gray-900">
                    {subTitle}
                </p>
                <span className="wc-btn wc-btn-normal fs-4 text-gray-800">
                    Read more
                    <i className="fa-solid fa-arrow-right"></i>
                </span>
            </div>
        </>
    )
}

export {Card_4}